/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getQuotationFormConfig } from "api/services/quotationForm";
import { quotationFormQueryKeys } from "./quotationFormQueryKeys";

export const useGetQuotationFormConfig = (id: string, options: UseQueryOptions) => {
  const queryRes = useQuery<any>({
    queryKey: quotationFormQueryKeys.config(id),
    queryFn: getQuotationFormConfigFn,
    ...options,
  });

  function getQuotationFormConfigFn() {
    return getQuotationFormConfig(id)
      .then((res: any) => {
        let responseData = res.data;
        if (responseData?.custom_service_confirmation?.NFO || responseData?.custom_service_confirmation?.OBC) {
          responseData = {
            ...responseData,
            custom_service_confirmation: {
              ...responseData.custom_service_confirmation,
              nfo: responseData.custom_service_confirmation.NFO,
              obc: responseData.custom_service_confirmation.OBC,
            },
          };
          delete responseData.custom_service_confirmation.OBC;
          delete responseData.custom_service_confirmation.NFO;
        }
        if (responseData?.freight_modes?.length) {
          responseData.freight_modes = responseData.freight_modes.map((item: any) => ({
            ...item,
            value: item.value.toLowerCase(),
          }));
        }
        return Promise.resolve(responseData);
      })
      .catch((err) => Promise.reject(err));
  }

  return queryRes;
};
